import { render, staticRenderFns } from "./SalutationField.vue?vue&type=template&id=37f44f75&"
import script from "./SalutationField.vue?vue&type=script&lang=js&"
export * from "./SalutationField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SalutationField.vue"
export default component.exports